module.exports = __webpack_public_path__ + "static/media/refrigerator.57cacfa4.svg";